import React from 'react';
import { Row, Col } from 'react-bootstrap';

import { IDownloadResultsPackageAPIResponse } from '@models';

import DownloadPackageBtn from './DownloadPackageBtn';
import InactiveReportBanner from './InactiveReportBanner';
import PackageSummaryContainer from './PackageSummaryContainer';
import './PackageInfoContainer.scss';

interface PackageInfoContainerProps {
  downloadPackage: IDownloadResultsPackageAPIResponse;
  inactiveSamples: number;
  packageId: string;
  timezone: string;
  uiSummaryListLength: number;
  projectId: string;
}

const PackageInfoContainer: React.FC<PackageInfoContainerProps> = ({
  downloadPackage,
  inactiveSamples,
  packageId,
  timezone,
  uiSummaryListLength,
  projectId,
}) => {
  return (
    <Row className='py-2'>
      <Col className='download-package-section'>
        <Row>
          <Col>
            <DownloadPackageBtn
              isDisabled={downloadPackage!.pkgInfo.state === 'ReportNA'}
              packageId={packageId}
              projectId={projectId}
            ></DownloadPackageBtn>
          </Col>
        </Row>
        {inactiveSamples > 0 ? (
          <InactiveReportBanner
            inactiveSamples={inactiveSamples}
          ></InactiveReportBanner>
        ) : null}
      </Col>
      <PackageSummaryContainer
        downloadPackage={downloadPackage}
        uiSummaryListLength={uiSummaryListLength}
        timezone={timezone}
      ></PackageSummaryContainer>
    </Row>
  );
};

export default PackageInfoContainer;
